import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_UPDATE_COLLECTION_ITEM_BEGIN,
  COLLECTIONS_UPDATE_COLLECTION_ITEM_SUCCESS,
  COLLECTIONS_UPDATE_COLLECTION_ITEM_FAILURE,
  COLLECTIONS_UPDATE_COLLECTION_ITEM_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function updateCollectionItem(args = {}) {
  delete args.data['_id'];
  delete args.data['uuid'];

  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_UPDATE_COLLECTION_ITEM_BEGIN,
    });
    const { projectId, version, collectionName, itemId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/collection/${itemId}`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            if (res.data.code && res.data.code !== 200) {
              const message = res.data.message;
              dispatch({
                type: COLLECTIONS_UPDATE_COLLECTION_ITEM_FAILURE,
                data: { error: message },
              });
              toast.error(`Failed: ${message}`);
              reject(res.data.data ? res.data.data : {});
            } else {
              dispatch({
                type: COLLECTIONS_UPDATE_COLLECTION_ITEM_SUCCESS,
                data: res.data,
                itemId: args.itemId,
              });
              toast.success('Updated Successfully !');
              resolve(res);
            }
          } else {
            dispatch({
              type: COLLECTIONS_UPDATE_COLLECTION_ITEM_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Updation Failed: ${errMsg} `);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_UPDATE_COLLECTION_ITEM_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Updation Failed: ${errMsg} `);

          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateCollectionItemError() {
  return {
    type: COLLECTIONS_UPDATE_COLLECTION_ITEM_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_UPDATE_COLLECTION_ITEM_BEGIN:
      return {
        ...state,
        updateCollectionItemPending: true,
        updateCollectionItemError: null,
      };

    case COLLECTIONS_UPDATE_COLLECTION_ITEM_SUCCESS:
      let items = state.items;
      let index = items.findIndex(function (item, i) {
        return item.uuid === action.itemId;
      });
      action.data.uuid = action.itemId;
      items[index] = action.data;
      return {
        ...state,
        updateCollectionItemPending: false,
        updateCollectionItemError: null,
        items: items,
        selectedItem: null,
      };

    case COLLECTIONS_UPDATE_COLLECTION_ITEM_FAILURE:
      return {
        ...state,
        updateCollectionItemPending: false,
        updateCollectionItemError: action.data.error,
      };

    case COLLECTIONS_UPDATE_COLLECTION_ITEM_DISMISS_ERROR:
      return {
        ...state,
        updateCollectionItemError: null,
      };

    default:
      return state;
  }
}
